import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SendUpiModal } from '../../shared/components/send-upi-modal/send-upi-modal';
import { ScanQrModal } from '../../shared/components/scan-qr-modal/scan-qr-modal';
import { OwnAccountModal } from '../../shared/components/own-account-modal/own-account-modal';
import { BankAccountModal } from '../../shared/components/bank-account-modal/bank-account-modal';

@Component({
  selector: 'app-transfer-fund',
  standalone: true,
  imports: [
    CommonModule,
    SendUpiModal,
    ScanQrModal,
    OwnAccountModal,
    BankAccountModal
  ],
  templateUrl: './transfer-fund.html',
  styleUrl: './transfer-fund.scss',
})
export class TransferFund {
  @Output() close = new EventEmitter<void>();
  activeView: 'selection' | 'send-upi' | 'receive' | 'bank' | 'own' | 'scan' = 'selection';

  constructor(private router: Router) { }

  openView(view: 'selection' | 'send-upi' | 'receive' | 'bank' | 'own' | 'scan') {
    this.activeView = view;
  }

  closeModal() {
    if (this.activeView === 'selection') {
      this.close.emit();
      this.router.navigate(['/dashboard']);
    } else {
      this.activeView = 'selection';
    }
  }
}
